import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import simHero from "../Assets/service6.jpg";

const SIMRegistrationAndGSMCards = () => {
  return (
    <div>
      <Fixed />
      <div className="bg-gray-50 text-gray-900 pt-24">
        {/* Hero Section */}
        <section
          className="relative w-full h-screen flex items-center justify-center bg-cover bg-center text-center text-white"
          style={{ backgroundImage: `url(${simHero})` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          <div className="relative z-10 px-6">
            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-5xl font-extrabold text-white"
            >
              SIM Registration & GSM SIM Cards
            </motion.h1>
            <p className="mt-4 text-lg max-w-3xl mx-auto">
              Secure and reliable SIM registration and GSM card solutions for seamless connectivity.
            </p>
          </div>
        </section>

        {/* Services Section */}
        <section className="container mx-auto px-6 py-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="bg-gradient-to-br from-blue-50 to-white shadow-lg rounded-lg p-10"
          >
            <h2 className="text-4xl font-bold text-blue-700 text-center">Our SIM & GSM Solutions</h2>
            <p className="mt-4 text-lg text-gray-700 text-center">
              Offering efficient SIM registration, secure activations, and high-quality GSM card solutions.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
              {[{
                  title: "Instant SIM Registration",
                  description: "Quick and secure SIM registration ensuring compliance with telecom regulations.",
                },
                {
                  title: "GSM SIM Cards",
                  description: "Reliable GSM SIM cards for seamless global and local connectivity.",
                },
                {
                  title: "Enterprise Solutions",
                  description: "Custom SIM solutions for businesses, ensuring security and scalability.",
                }
              ].map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-6 rounded-lg shadow-md border-b-4 border-blue-500"
                >
                  <h3 className="text-2xl font-semibold text-blue-600">{service.title}</h3>
                  <p className="mt-2 text-gray-700">{service.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </section>

        {/* Why Choose Us Section */}
        <section className="bg-gradient-to-r from-blue-50 to-white py-16">
          <div className="container mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-blue-800">Why Choose Our Services?</h2>
            <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
              Experience hassle-free activation, secure registration, and high-speed connectivity with our premium SIM solutions.
            </p>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-10">
              {[{
                  title: "Secure Registration",
                  description: "Our process ensures compliance with government and telecom regulations.",
                  icon: "🔒",
                },
                {
                  title: "Fast Activation",
                  description: "Get your SIM card activated instantly with minimal documentation.",
                  icon: "⚡",
                },
                {
                  title: "Global Connectivity",
                  description: "Stay connected with GSM SIM cards offering worldwide coverage.",
                  icon: "🌍",
                }
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: index * 0.2 }}
                  className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-blue-500 flex flex-col items-center"
                >
                  <div className="text-5xl">{feature.icon}</div>
                  <h3 className="text-2xl font-semibold text-blue-700 mt-4">{feature.title}</h3>
                  <p className="mt-2 text-gray-600 text-center">{feature.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Call to Action Section */}
        <section className="py-16 text-center bg-white border-t border-gray-300">
          <div className="container mx-auto px-6">
            <h2 className="text-4xl font-bold text-blue-800">Get Your SIM Registered Today</h2>
            <p className="mt-4 text-lg text-gray-700">Ensure secure and seamless connectivity with our trusted solutions.</p>
          </div>
        </section>
      </div>
      <Footer1 />
    </div>
  );
};

export default SIMRegistrationAndGSMCards;
